import angular from 'angular';
import Main from './main/main';
import User from './user/user';
import Premium from './premium/premium';
import Home from './home/home';
import About from './about/about';
import Auth from './auth/auth';
import Plan from './plan/plan';
import Post from './post/post';
import Product from './product/product';
import Category from './category/category';

const componentModule = angular.module('app.components', [
  Main,
  Home,
  User,
  About,
  Auth,
  Plan,
  Premium,
  Post,
  Product,
  Category,
]).name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js